import Settings from "./Setting";
import Common from "./Common";

const reducers = {
  settings: Settings,
  common: Common,
};

export default reducers;
